import { DashboardShell } from "./DashboardShell";
import { MetricCard } from "./MetricCard";
import { ChartCard } from "./ChartCard";
import { ActivityPanel } from "./ActivityPanel";
import { crmPreview } from "@/data/dashboardPreview.data";
import { DashboardContent } from "./DashboardContent";

interface Props {
    accent: string;
}

export function CRMDashboard({
    accent,
}: Props) {
    const preview = crmPreview;

    return (
        <DashboardShell
            accent={accent}
            title="Customer Relationship Management"
            subtitle="AI-assisted sales and customer engagement"
            sidebar={[
                "Dashboard",
                "Leads",
                "Accounts",
                "Contacts",
                "Opportunities",
                "Activities",
                "Forecast",
                "Reports",
            ]}
        >
            <DashboardContent

                accent={accent}

                preview={preview}

                activityTitle="Sales Activity"

            />

            <div className="mt-6 grid gap-3 md:grid-cols-4">

                {
                    [
                        {
                            label: "Lead Conversion",
                            value: "38%",
                            trend: "+6%"
                        },
                        {
                            label: "Average Deal",
                            value: "$24K",
                            trend: "+12%"
                        },
                        {
                            label: "Customer Retention",
                            value: "94%",
                            trend: "+3%"
                        },
                        {
                            label: "Sales Target",
                            value: "108%",
                            trend: "Exceeded"
                        },
                    ].map((metric) => (

                        <MetricCard
                            key={metric.label}
                            accent={accent}
                            label={metric.label}
                            value={metric.value}
                            trend={metric.trend}
                        />

                    ))
                }

            </div>

            {/* <div className="grid gap-4"> */}


                {/* ======================================================
                   CRM Operations
                ====================================================== */}

                {/* <div className="grid gap-6 lg:grid-cols-3">

                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Sales Pipeline
                        </h3>

                        <div className="mt-5 space-y-5">

                            {[
                                {
                                    stage: "Qualified",
                                    value: 82,
                                },
                                {
                                    stage: "Proposal",
                                    value: 63,
                                },
                                {
                                    stage: "Negotiation",
                                    value: 48,
                                },
                                {
                                    stage: "Closing",
                                    value: 29,
                                },
                            ].map((stage) => (
                                <div key={stage.stage}>

                                    <div className="flex justify-between text-sm">

                                        <span>{stage.stage}</span>

                                        <span>{stage.value}</span>

                                    </div>

                                    <div className="mt-2 h-2 rounded-full bg-muted">

                                        <div
                                            className="h-full rounded-full"
                                            style={{
                                                width: `${stage.value}%`,
                                                background: accent,
                                            }}
                                        />

                                    </div>

                                </div>
                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            AI Sales Assistant
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                "12 high-value leads require immediate follow-up.",
                                "Forecast indicates 18% revenue growth next quarter.",
                                "Generate proposal for Acme Manufacturing.",
                                "3 customers likely to renew this month.",
                            ].map((item) => (

                                <div
                                    key={item}
                                    className="rounded-xl border border-border p-4"
                                >

                                    <p className="text-sm leading-relaxed">
                                        {item}
                                    </p>

                                </div>

                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Today's Follow-ups
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                {
                                    company: "ABC Industries",
                                    time: "10:00 AM",
                                },
                                {
                                    company: "Metro Hospital",
                                    time: "11:30 AM",
                                },
                                {
                                    company: "Smart Logistics",
                                    time: "02:00 PM",
                                },
                                {
                                    company: "Green Energy Ltd.",
                                    time: "04:30 PM",
                                },
                            ].map((row) => (

                                <div
                                    key={row.company}
                                    className="flex items-center justify-between rounded-xl border border-border px-4 py-3"
                                >

                                    <div>

                                        <p className="font-medium">
                                            {row.company}
                                        </p>

                                        <p className="text-xs text-muted-foreground">
                                            Customer Follow-up
                                        </p>

                                    </div>

                                    <span
                                        className="rounded-full px-3 py-1 text-xs font-semibold"
                                        style={{
                                            background: `${accent}15`,
                                            color: accent,
                                        }}
                                    >
                                        {row.time}
                                    </span>

                                </div>

                            ))}

                        </div>

                    </div>

                </div> */}

            {/* </div> */}

        </DashboardShell>

    );
}